import { render, staticRenderFns } from "./BookChapters.vue?vue&type=template&id=115430e8&scoped=true"
import script from "./BookChapters.vue?vue&type=script&lang=js"
export * from "./BookChapters.vue?vue&type=script&lang=js"
import style0 from "./BookChapters.vue?vue&type=style&index=0&id=115430e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115430e8",
  null
  
)

export default component.exports